import React from "react";

import styled from "styled-components/macro";

import { baseButtonStyles } from "../../styles/sharedStyles";

type TAnchorWrapper = {
  $isBlack?: boolean,
  $hasBorder?: boolean,
  $bgColor?: string;
}

const AnchorWrapper = styled.a<TAnchorWrapper>`
 ${baseButtonStyles};
 border-color: ${({ $hasBorder }) => $hasBorder ? "#141414" : "#fff"};
`

type TButtonLink = {
  href: string,
  title: string,
  hasBorder?: boolean,
  bgColor?: string;
  isBlack?: boolean,
}

export const ButtonAnchor: React.FC<TButtonLink> = ({
  href,
  title,
  hasBorder= true,
  isBlack = false,
}) => {
  return (
    <AnchorWrapper
      href={href}
      $hasBorder={hasBorder}
      $isBlack={isBlack}
      target="_blank"
      rel="noopener noreferrer"
    >
      {title}
    </AnchorWrapper>
  )
}

